import { createApi } from "@reduxjs/toolkit/query/react";
import { getAdminAxiosInstance } from "../../../api/Admin";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    const api = await getAdminAxiosInstance();
    const getParams = (key) => {
      if (params?.[key]) {
        return `${key}=${params[key]}&`;
      } else {
        return "";
      }
    };
    if (method === "get") {
      try {
        const response = await api[method](
          `${endpoint}?${getParams("start_date")}${getParams(
            "end_date"
          )}filter=${params?.filter || "all"}&${getParams("sort")}sort_order=${
            params?.sort_order || "desc"
          }&per_page=${params?.page_size || "20"}&nationality=${
            params?.nationality || ""
          }&${getParams("search")}page=${params?.page || ""}&${getParams(
            "user_id"
          )}`,
          body
        );
        return { data: response.data };
      } catch (axiosError) {
        let err = axiosError;
        return {
          error: {
            status: err.response?.status,
            data: err.response?.data || err.message,
          },
        };
      }
    } else {
      try {
        const response = await api[method](
          `${endpoint}${getParams("start")}${getParams("end")}${getParams(
            "sort"
          )}${getParams("search")}`,
          body
        );
        return { data: response.data };
      } catch (axiosError) {
        let err = axiosError;
        return {
          error: {
            status: err.response?.status,
            data: err.response?.data || err.message,
          },
        };
      }
    }
  };

export const user = createApi({
  reducerPath: "userApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    "User",
    "UserProfile",
    "OrderListing",
    "PointHistory",
    "Transactions",
    "TransactionType",
    "StoreListing",
    "ProductListing",
    "vehicleListing",
    "Custom Offer",
    "Video Banner",
    "UserBasicData",
    "profileActivityLog",
    "Splash"
  ],
  endpoints: (builder) => ({
    getUserListData: builder.query({
      query: (body) => ({
        method: "post",
        body,
        endpoint: "/user/index",
      }),
      providesTags: ["User"],
    }),
    updateUserTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-field/store`,
      }),

      invalidatesTags: ["User"],
    }),
    getUserDetailData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/user/show`,
      }),
      providesTags: ["UserProfile"],
    }),
    getOrderListingData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/order/list`,
      }),
      providesTags: ["OrderListing"],
    }),
    updateOrderListingTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-field/store`,
      }),

      invalidatesTags: ["OrderListing"],
    }),
    getPointHistoryData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/user/point-history`,
      }),
      providesTags: ["PointHistory"],
    }),
    updatePointHistoryTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-field/store`,
      }),

      invalidatesTags: ["PointHistory"],
    }),
    getTransactionsData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/user-wallet-transaction`,
      }),
      providesTags: ["Transactions"],
    }),
    updateTransactionTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-field/store`,
      }),

      invalidatesTags: ["Transactions"],
    }),
    // transaction type starts here
    getTransactionsTypeData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/transaction-type/index`,
      }),
      providesTags: ["TransactionType"],
    }),
    updateTransactionTypeTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-field/store`,
      }),
      invalidatesTags: ["TransactionType"],
    }),
    // transaction type ends here

    // userStore list starts here
    getStoreListingData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `favourite/store-list`,
      }),
      providesTags: ["StoreListing"],
    }),
    updateStoreListTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-field/store`,
      }),

      invalidatesTags: ["StoreListing"],
    }),
    // userStore list ends here

    // user Product list starts here
    getproductListingData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `favourite/product-list`,
      }),
      providesTags: ["ProductListing"],
    }),
    updateProductListTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-field/store`,
      }),

      invalidatesTags: ["ProductListing"],
    }),
    // user Product list ends here

    // vehicleListing starts here
    getVehicleListingData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `vehicle-details/index`,
      }),
      providesTags: ["vehicleListing"],
    }),
    updateVehicleListTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-field/store`,
      }),

      invalidatesTags: ["vehicleListing"],
    }),
    //vehicleListing ends here

     //profile activity log starts here
     getProfileActivityLogData: builder.query({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user/profile-log-list`,
      }),
      providesTags: ["profileActivityLog"],
    }),
    updateProfileActivityLogTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-field/store`,
      }),

      invalidatesTags: ["profileActivityLog"],
    }),
    //profile activity log ends here

    //custom offers section start here
    getCustomOffersListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/offer/list`,
      }),
      providesTags: ["Custom Offer"],
    }),
    updateCustomOffersTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: "/user-field/store",
      }),
      invalidatesTags: ["Custom Offer"],
    }),
    getCustomOffersBasicData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/offer/basic-data`,
      }),
      providesTags: ["Custom Offer"],
    }),

    //custom offers ends here
    //gift cards section starts here
    getGiftCardListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/gift-card/index`,
      }),
      providesTags: ["Gift Card"],
    }),
    updateGiftCardTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: "/user-field/store",
      }),
      invalidatesTags: ["Gift Card"],
    }),
    //gift card section ends here
    //feedback section starts
    getFeedbackListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/feed-back/list`,
      }),
      providesTags: ["Feedback"],
    }),
    updateFeedbackTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: "/user-field/store",
      }),
      invalidatesTags: ["Feedback"],
    }),
    //feedback section ends here

    //video  banner section starts here
    getVideoBannerListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/banner/video-list`,
      }),
      providesTags: ["Video Banner"],
    }),
    updateVideoBannerTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: "/user-field/store",
      }),
      invalidatesTags: ["Video Banner"],
    }),
    getVideoBanner: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: "/banner/video-upload",
      }),
    }),
    createVideoBanner: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: "/banner/video-store",
      }),
    }),
    updateVideoBannerStatus: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `video/change-status`,
      }),
    }),
    //video banner section ends here

    //user basic data section starts here
    getUserBasicData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: "/user/basic-data",
      }),
      providesTags: ["UserBasicData"],
    }),
    //user basic data section ends here


    //Survey section starts

    getSurveyListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: "/survey/question-list",
      }),
      providesTags: ["Survey"],
    }),
    getSurveyBasicData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: "/survey/basic-data",
      }),
      keepUnusedDataFor: 60,
      providesTags: ["Survey"],
    }),
    updateSurveyTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-field/store`,
      }),

      invalidatesTags: ["Survey"],
    }),

     //splash screen section starts
    getSplashScreenListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: "splash-screen/list",
      }),
      providesTags: ["Splash"],
    }),
    updateSplashScreenHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-field/store`,
      }),
      invalidatesTags: ["Banner"],
    }),
    updateSplashScreenStatus: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `splash-screen/change-status`,
      }),
    }),
     //Placeholder section starts
    getPlaceholderListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: "search/list",
      }),
      providesTags: ["Splash"],
    }),
    updatePlaceholderHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-field/store`,
      }),
      invalidatesTags: ["Banner"],
    }),
    updatePlaceholderStatus: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `search/change-status`,
      }),
    }),
    getPlaceholderBasicData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: "/search/basic-data",
      }),
      keepUnusedDataFor: 60,
    }),
    //Seasonal theme section starts
    getSeasonalThemeListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: "seasonal-theme/list",
      }),
      providesTags: ["Splash"],
    }),
    updateSeasonalThemeHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-field/store`,
      }),
      invalidatesTags: ["Banner"],
    }),
    updateSeasonalThemeStatus: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `seasonal-theme/change-status`,
      }),
    }),
    getSeasonalThemeBasicData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: "/seasonal-theme/basic-data",
      }),
      keepUnusedDataFor: 60,
    }),
     //Popular search section starts
    getPopularSearchListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: "popular-search/list",
      }),
      providesTags: ["Splash"],
    }),
    updatePopularSearchHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-field/store`,
      }),
      invalidatesTags: ["Banner"],
    }),
    updatePopularSearchStatus: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `popular-search/change-status`,
      }),
    }),
    getPopularSearchBasicData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: "/popular-search/basic-data",
      }),
      keepUnusedDataFor: 60,
    }),
     //Office delivery section starts
    getOfficeDeliveryListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: "office-delivery/list",
      }),
      providesTags: ["Splash"],
    }),
    updateOfficeDeliveryHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-field/store`,
      }),
      invalidatesTags: ["Banner"],
    }),
    updateOfficeDeliveryStatus: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `office-delivery/change-status`,
      }),
    }),
    getOfficeDeliveryBasicData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: "/office-delivery/basic-data",
      }),
      keepUnusedDataFor: 60,
    }),
    getFavouriteCategoryListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: "favourite-category-icon/list",
      }),
      providesTags: ["favourite-category"],
    }),
    updateFavouriteCategoryTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-field/store`,
      }),

      invalidatesTags: ["favourite-category"],
    }),
  }),
});

export const {
  useGetUserListDataQuery,
  useGetOrderListingDataQuery,
  useGetPointHistoryDataQuery,
  useGetTransactionsDataQuery,
  useGetUserDetailDataQuery,
  useUpdateUserTableHeadDataMutation,
  useGetTransactionsTypeDataQuery,
  useUpdateTransactionTypeTableHeadDataMutation,
  useGetStoreListingDataQuery,
  useGetproductListingDataQuery,
  useGetVehicleListingDataQuery,
  useUpdateOrderListingTableHeadDataMutation,
  useUpdatePointHistoryTableHeadDataMutation,
  useUpdateProductListTableHeadDataMutation,
  useUpdateStoreListTableHeadDataMutation,
  useUpdateTransactionTableHeadDataMutation,
  useUpdateVehicleListTableHeadDataMutation,
  useGetCustomOffersListDataQuery,
  useUpdateCustomOffersTableHeadDataMutation,
  useGetCustomOffersBasicDataQuery,
  useGetGiftCardListDataQuery,
  useUpdateGiftCardTableHeadDataMutation,
  useGetFeedbackListDataQuery,
  useUpdateFeedbackTableHeadDataMutation,
  useGetVideoBannerListDataQuery,
  useUpdateVideoBannerTableHeadDataMutation,
  useGetVideoBannerMutation,
  useCreateVideoBannerMutation,
  useUpdateVideoBannerStatusMutation,
  useGetUserBasicDataQuery,
  useGetSurveyListDataQuery,
  useGetSurveyBasicDataQuery,
  useUpdateSurveyTableHeadDataMutation,
  useGetProfileActivityLogDataQuery,
  useUpdateProfileActivityLogTableHeadDataMutation,
  useGetSplashScreenListDataQuery,
  useUpdateSplashScreenHeadDataMutation,
  useUpdateSplashScreenStatusMutation,
  useGetPlaceholderListDataQuery,
  useUpdatePlaceholderHeadDataMutation,
  useUpdatePlaceholderStatusMutation,
  useGetPlaceholderBasicDataQuery,
  useGetSeasonalThemeListDataQuery,
  useUpdateSeasonalThemeHeadDataMutation,
  useUpdateSeasonalThemeStatusMutation,
  useGetSeasonalThemeBasicDataQuery,
  useGetPopularSearchListDataQuery,
  useUpdatePopularSearchHeadDataMutation,
  useUpdatePopularSearchStatusMutation,
  useGetPopularSearchBasicDataQuery,
  useGetOfficeDeliveryListDataQuery,
  useUpdateOfficeDeliveryHeadDataMutation,
  useUpdateOfficeDeliveryStatusMutation,
  useGetOfficeDeliveryBasicDataQuery,
  useGetFavouriteCategoryListDataQuery,
  useUpdateFavouriteCategoryTableHeadDataMutation,
} = user;
